import type { FaireProductEntity } from "../../entity_types/product";

export const p_qzcn9m4w39: FaireProductEntity = {
  token: "p_qzcn9m4w39",
  type: "product",
  name: "Raspberry Rose Hydrate - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/4d53c43420052bc620ba85608703d417549b06050ec4a0d3c207149bbea2c060.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ff5dfaf6b417b2a71af398da3bb6f14bcf44d598b16085f71455fa08008c197.png"
  ],
  priceDollars: 58,
  description: "SUPERFOOD TEA BLEND \n\nBut first, hydration! \n\nThis refreshing pink beauty was designed for your summer bod' in mind, with juicy pieces of real raspberry and strawberry, and nourishing herbs like rose hips and raspberry leaf. It drinks like a summery kool-aid, but for the wellness girlies (superfoods and whole leaf tea only please!) Try me iced with a drizzle of honey or maple syrup, and get your glow from head to toe. \n\n100% ORGANIC - NUTRITIONIST FORMULATED - SUGAR FREE\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Steep 2 heaping teaspoons of tea in ¾ cup boiling water for at least 5 minutes. Sweeten to taste. Top with 1 cup of ice to cool. \n * In a large jar, combine 3 tbsp of tea for 1 litre of water. Refrigerate overnight, or up to 2 days. Strain, sweeten and enjoy. \n * Steep tea double strength and top with sparkling water, fruits and herbs. We love fresh berries and mint! \nWhen to Steep:\n\n * As a part of your daily wellness ritual \n * To hydrate and re-energize after working out, or after a day in the sun \n * To stay grounded and de-stress throughout the day. \n * As a healthy swap for coffee or your evening cocktail \nCaffeine-free\n\n\n\n",
  tags: [],
  msrpDollars: 116,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:45.551Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
